import {
  MainnetLockingContract,
  PulseLockingContract,
  PulseTestLockingContract,
  TestLockingContract,
  TestMainWaitContract,
  TestWaitContract,
  WaitContract,
} from 'libs/data/contracts'
import { useAccount, useChainId } from 'wagmi'

import useRead from './useRead'

export default (): any => {
  const validate = (value: unknown): value is bigint => typeof value === 'bigint'
  const account = useAccount()
  const chainId = useChainId()

  const waitAddress =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? TestWaitContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestMainWaitContract.address
        : process.env.NEXT_PUBLIC_ENV != 'development'
          ? WaitContract.address
          : WaitContract.address
  const abi = process.env.NEXT_PUBLIC_ENV == 'development' ? TestWaitContract.abi : WaitContract.abi
  const addr =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.address
        : chainId == 1
          ? MainnetLockingContract.address
          : PulseLockingContract.address
  return useRead({
    contract: waitAddress as `0x${string}`,
    abi: abi,
    functionName: 'allowance',
    args: [account.address, addr],
    validate,
  })
}
